 $(window).on('load resize orientationchange', function() 
{
    /* 
        THE PURPOSE OF THIS SCEIPT IS SO THAT Bootstrap 5's TABS CAN
        BECOME DROPDOWN TABS ON SMALLER DEVICES

        ul.nav-tabs.responsive-tabs-container (note the extra class)
            li.nav-item (as if only making tabs)
            li.nav-item.responsive-tabs-dropdown (container for nested tabs on small)
                a.nav-link.dropdown-toggle (dropdown button small)
                    ul.dropdown-menu (dropdown menu on small)
                        li.nav-item responsive-tabs-tab (the items that toggle between being tabs and large and dopdown items for small)

    */

    let responsiveContainerName = '.responsive-tabs-container';
    let responsiveContainer = $(responsiveContainerName);

    let responsiveDropdownName = '.responsive-tabs-dropdown';
    let responsiveDropdown = $(responsiveDropdownName);

    let responsiveTabsName = '.responsive-tabs-tab'; 
    let responsiveTabs = $(responsiveTabsName);

    if (responsiveContainer.length && responsiveTabs.length && responsiveDropdown.length)
    {
       
        // if it's a large screen and not already moved, move the elements out of the dropdown ul
        if ($(window).width() > 1023) 
        {
            responsiveTabs.each(function(i, obj)
            {
                if ($(this).parents(responsiveDropdownName).length) 
                {
                    let parent = $(this).closest(responsiveContainerName);
                    $(this).detach().appendTo(parent);
                }
            });
            responsiveDropdown.hide();
        }
        else
        {
            responsiveTabs.each(function(i, obj)
            {
                if (!$(this).parents(responsiveDropdownName).length) 
                {
                    let parent = $(this).closest(responsiveContainerName);
                    let dropdown = parent.find(responsiveDropdownName + " ul");
                    $(this).detach().appendTo(dropdown);
                }
            });
            responsiveDropdown.show();
        }
    }

});

$(document).ready(function ()
{

    $('button.nav-link').click(function(e)
    {
        e.preventDefault();
        let copy = $(this).html();
        let rBtn = $(this).data('rbtn');
        $('#' + rBtn).html(copy);
    });

});
